import CLIENT from "../../lib/api/client";
import ENDPOINTS from "../../lib/api/endpoints";
import { addressFromCoords, addressFromGeocode } from "../auth/authMappers";

export const resolveAddress = async (label, coords, countryCode) => {
  if (coords) {
    try {
      const { data } = await CLIENT.get(ENDPOINTS.ADDRESS.fromLocation, {
        params: { latitude: coords.latitude, longitude: coords.longitude },
      });

      const mapped = addressFromGeocode(data, label);
      if (mapped) return mapped;
    } catch {
      /* fall through to the client-side builder */
    }
  }

  return addressFromCoords(label, coords, countryCode);
};
